import { isEqual, template, get } from 'lodash';
import { encodeLocTypePath } from '../../../ui-internal-account/src/utilities/launchTiles';
import * as tConst from '../constants/tabs';
import { FIELD_SALES_SALES_CHANNEL } from '../constants/types';

export function toTabNumber(editTab, locationTypes = []) {
    let value = 0;
    for (let i = 0; i < tConst.tabOrder.length; i++) {
        const tabLocation = tConst.tabOrder[i];
        if (locationTypes.includes(tabLocation) || isEqual(tabLocation, tConst.PASS_TAB) || isEqual(tabLocation, tConst.POS_TAB)) {
            if (isEqual(editTab, tabLocation)) {
                return value;
            }
            value += 1;
        }
    }

    // Default to no tab selected
    return -1;
}

export function getLocationSalesUrl(tabLocation, locationId, salesChannel, locationType) {
    const url = template(get(tConst.tabLookup[tabLocation], 'url'));
    const destination = url({
        sales_type: tConst.salesUrlIdentifierLookup[salesChannel],
        location_id: locationId,
        location_type: encodeLocTypePath(locationType || tabLocation) || tabLocation
    });
    return destination;
}

export function getReservationEditUrl(tabLocation, locationId, salesChannel = FIELD_SALES_SALES_CHANNEL, reservationId = "") {
    const templateUrl = get(tConst.tabLookup[tabLocation], 'editUrl', '');

    if (templateUrl === '') {
        return null;
    }
    const url = template(templateUrl);
    const destination = url({
        sales_type: tConst.salesUrlIdentifierLookup[salesChannel],
        location_id: locationId,
        location_type: tabLocation,
        reservation_id: reservationId
    });
    return destination;
}

export function toTabName(num, locationId, locationTypes = [], salesChannel = FIELD_SALES_SALES_CHANNEL, locationType) {
    let value = num;
    for (let i = 0; i < tConst.tabOrder.length; i++) {
        const tabLocation = tConst.tabOrder[i];
        if (locationTypes.includes(tabLocation) || isEqual(tabLocation, tConst.PASS_TAB) || isEqual(tabLocation, tConst.POS_TAB)) {
            if (value === 0) {
                const destination = getLocationSalesUrl(tabLocation, locationId, salesChannel, locationType);
                window.location.assign(destination);
            }
            value -= 1;
        }
    }
    return null;
}
